import { Api, Codes } from '../api';
import Moment from 'moment';
export default class {
  get diff() {
    let timeObj = this.baseServerTime || Moment();
    return timeObj.diff(this.baseTime);
  }
  constructor(options) {
    let defaults = {
      baseServerTime: null
    };
    let _options = { ...defaults, ...options };
    for (let key in _options) {
      this[key] = _options[key];
    }
    this.initial();
  }
  initial = async () => {
    this.baseServerTime = await this.getServerTime();
    this.baseTime = Moment();
  };
  isOverDateServer = async date => {
    let serverTime = await this.getServerTime();
    return Moment(date).diff(Moment(serverTime));
  };
  isOverDate = (date, base) => {
    let _date = Moment(date);
    let target = Moment(Moment(_date) - this.diff);
    let now;
    if (base) {
      now = Moment(Moment(base) - this.diff);
    } else {
      now = Moment();
    }
    return Moment(base).diff(target) >= 0;
  };
  isBetweenDate = (date1, date2, base) => {
    let _date1 = Moment(date1);
    let _date2 = Moment(date2);
    let target1 = Moment(Moment(_date1) - this.diff);
    let target2 = Moment(Moment(_date2) - this.diff);
    let now;
    if (base) {
      now = Moment(Moment(base) - this.diff);
    } else {
      now = Moment();
    }
    return now.diff(target1) >= 0 && now.diff(target2) <= 0;
  };
  getServerTime = async () => {
    let ret = Moment();
    if (Api?.get?.getServerTime) {
      let res = await Api.get.getServerTime();
      if (res.status === Codes.SUCCESS) {
        ret = Moment(res.data);
      }
    } else {
      setTimeout(async () => {
        this.baseServerTime = await this.getServerTime();
      }, 1000);
    }
    return ret;
  };
  getDiff = date => {
    let _date = Moment(date);
    let target = Moment(Moment(_date) - this.diff);
    return target.diff(Moment());
  };
  isOver20210805200000 = () => {
    return this.isOverDate('2021-08-05 20:00:00');
  };
  isOver20210806200000 = () => {
    return this.isOverDate('2021-08-06 20:00:00');
  };
  isOver20210807200000 = () => {
    return this.isOverDate('2021-08-07 20:00:00');
  };
  isOver20210809090000 = () => {
    return process.env.NODE_ENV === 'development' ? true : this.isOverDate('2021-08-09 09:00:00');
  };
  isOver20210811101000 = () => {
    return this.isOverDate('2021-08-11 10:10:00');
  };
  isOver20210810164300 = () => {
    return this.isOverDate('2021-08-10 16:45:00');
  };
  isDateIntersection = (start1, end1, start2, end2) => {
    var startDate1 = Moment(start1);
    var endDate1 = Moment(end1);
    var startDate2 = Moment(start2);
    var endDate2 = Moment(end2);
    if (startDate1.diff(startDate2) >= 0 && startDate1.diff(endDate2) <= 0) {
      return true;
    }
    if (endDate1.diff(startDate2) >= 0 && endDate1.diff(endDate2) <= 0) {
      return true;
    }
    if (startDate1.diff(startDate2) <= 0 && endDate1.diff(endDate2) >= 0) {
      return true;
    }
    return false;
  };
}
